import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Tags from '../components/Tags'
import Avatars from '../components/Avatars'
import Tables from '../components/Tables'

const Display = (props: any) => {
  const { path } = props.match
  return (
    <Switch>
      <Route path={`${path}/avatars`}>
        <Avatars />
      </Route>
      <Route path={`${path}/tags`}>
        <Tags />
      </Route>
      <Route path={`${path}/tables`}>
        <Tables />
      </Route>
    </Switch>
  )
}

export default Display
